// Consent Provider component
import { createContext, useContext, ReactNode } from "react";
import { useConsent, UseConsentReturn } from "../hooks/useConsent";

// Create context for consent management
const ConsentContext = createContext<UseConsentReturn | null>(null);

// Hook to use consent context
export function useConsentContext(): UseConsentReturn {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error("useConsentContext must be used within a ConsentProvider");
  }
  return context;
}

interface ConsentProviderProps {
  children: ReactNode;
}

export function ConsentProvider({ children }: ConsentProviderProps) {
  const consentData = useConsent();

  return <ConsentContext.Provider value={consentData}>{children}</ConsentContext.Provider>;
}
